module.exports = __webpack_public_path__ + "static/img/2.7ddb389.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/2.png
// module id = ocm9
// module chunks = 0